import { render, staticRenderFns } from "./access-strategy.vue?vue&type=template&id=7c7185df&"
import script from "./access-strategy.vue?vue&type=script&lang=js&"
export * from "./access-strategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports